<template>
  <v-row dense>
    <v-col cols="4">
      <v-select
        v-model="form.app_id"
        :loading="!!!apps.length"
        :items="apps"
        item-text="name"
        item-value="id"
        :rules="rules.requiredSelectNotArray"
        :label="`${$t('BUILDING_COMPLEXES.APP')} *`"
        :error-messages="errors.app_id"
        :readonly="readonly"
        @change="unselectTilesGroup($event)"
      />
    </v-col>
    <v-col cols="4">
      <v-select
        v-model="form.tiles_group_id"
        :items="tilesGroups"
        item-text="name"
        item-value="id"
        :disabled="!form.app_id"
        :rules="rules.requiredSelectNotArray"
        :label="`${$t('BUILDING_COMPLEXES.TILES_GROUP')} *`"
        :error-messages="errors.tiles_group_id"
        :readonly="readonly"
        @change="updateValue('tiles_group_id', $event)"
      />
    </v-col>
    <v-col col="4">
      <v-select
        v-model="form.smarthome_tiles_group_id"
        :loading="!!!smartHomeItems.length"
        :items="smartHomeItems"
        item-text="name"
        item-value="id"
        :label="
          `${$t('SMARTHOME.ITEM')} ${$t('BUILDING_COMPLEXES.TILES_GROUP')}`
        "
        :error-messages="errors.smarthome_tiles_group_id"
        :readonly="readonly"
        @change="updateValue('smarthome_tiles_group_id', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import { TilesService } from '@/services/tiles.service';
import { requiredSelectNotArray } from '@/modules/_global/variables/rules';
import { mapActions, mapGetters } from 'vuex';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'AppSettingsForm',

  mixins: [formEditable],

  data() {
    return {
      apps: [],
      smartHomeItems: [],

      rules: {
        requiredSelectNotArray
      },

      form: {
        app_id: null,
        tiles_group_id: null,
        tiles_group: {}
      }
    };
  },

  computed: {
    ...mapGetters('tile', {
      tilesGroups: 'GET_TILES_GROUPS'
    })
  },

  watch: {
    'form.tiles_group.app_id': {
      immediate: true,
      handler: 'changeAppId'
    }
  },

  created() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('smarthome', ['getSmartHomeDevicesAppID']),
    ...mapActions('tile', ['getTilesGroups']),
    ...mapActions('apps', ['index']),

    getDataSmartHomeItems() {
      this.getSmartHomeDevicesAppID().then(data => {
        TilesService.getTilesGroupsById(data.data.id).then(({ data }) => {
          this.smartHomeItems = data.data;
        });
      });
    },

    getDataApps() {
      this.index().then(({ data }) => {
        this.apps = data;
      });
    },

    getDataTilesGroups(v = this.form.app_id) {
      this.getTilesGroups({ applicationId: v });
    },

    unselectTilesGroup(e) {
      this.form.tiles_group_id = null;
      this.getDataTilesGroups(e);
      this.updateValue('app_id', e);
    },

    changeAppId(v) {
      if (v) {
        // in prev version building complex didn't have tiles group
        this.form.app_id = v;
        this.updateValue('app_id', v);
        this.getDataTilesGroups(v);
      } else {
        //console.log('building complex - old version');
      }
    },

    refreshData() {
      this.getDataApps();
      this.getDataSmartHomeItems();
    }
  }
};
</script>
